export const iconFontAwesomeSportsFitnessPersonSnowboarding = (
	<i className="fa-solid fa-person-snowboarding"></i>
);
